<template>
	<nta-page-layout>
		<template #default>
			<div style="width: 100%; height: 100%" class="d-flex justify-center align-center">
				<!-- Banner -->
				<AlternisBanner style="position: absolute; top: 50px; left: 0px" />

				<!-- LEFT -->
				<div style="width: 50%; height: 100%; overflow: hidden">
					<AlternisGlobe
						:showLines="true"
						:showRegions="false"
						:showLabels="false"
						style="margin-top: 250px; margin-left: 70px"
					/>
				</div>

				<!-- RIGHT -->
				<div style="width: 50%; height: 100%">
					<div style="width: 100%; height: 100%" class="d-flex justify-center align-center">
						<!-- PARTNER SELECTION -->
						<!-- NOT NEEDED RIGHT NOW, 04.02.25, jnhck
						<v-card v-if="!partner" color="contained" rounded="lg" width="500px">
							<v-card-title style="text-align: center">
								<h2>Partner</h2>
							</v-card-title>
							<v-card-text class="d-flex justify-center align-center flex-wrap">
								<v-btn
									v-for="p in partners"
									:key="p.id"
									style="width: 200px"
									class="ma-2"
									:color="p.color"
									@click="partner = p"
									>{{ p.name }}</v-btn
								>
							</v-card-text>
						</v-card> 
						-->
						<!-- WORKSPACES -->
						<v-card color="contained" rounded="lg">
							<v-card-text>
								<v-list
									v-if="workspaces.length > 0"
									style="max-height: 40vh; overflow-y: auto; padding: 0"
									rounded="lg"
								>
									<v-list-item
										v-for="workspace in workspaces"
										:key="workspace.id"
										class="d-flex align-center"
										title="Voicebot Anruf"
										:subtitle="new Date(workspace.timestamp).toLocaleString('de-DE')"
										prepend-icon="mdi-phone-in-talk"
										@click="workspaceClick(workspace.id)"
									>
										<template #append>
											<v-icon v-show="!workspace.clicked" size="x-large" color="success">
												mdi-new-box
											</v-icon>
											<v-icon v-show="workspace.clicked" size="x-large" color="#E3E5EA">
												mdi-check-bold
											</v-icon>
										</template>
									</v-list-item>
								</v-list>
								<v-alert v-else>
									<div>Noch keine neuen Calls eingetroffen.</div>
								</v-alert>
							</v-card-text>
						</v-card>
					</div>
				</div>

				<!-- Footer -->
				<!-- <div style="position: absolute; bottom: 0; left: 0">
					<PartnerLogo v-if="partner" :logoUrl="partner.logo" />
				</div> -->
				<div style="position: absolute; bottom: 0; right: 0">
					<PhoneCallQRCode v-if="partner" :id="partner.id" />
				</div>
			</div>
		</template>
	</nta-page-layout>
</template>

<script setup lang="ts">
import { ref, watch, onMounted } from "vue";
import { api } from "@lr-notitia/notitia-operator/client";
import AlternisGlobe from "../components/AlternisGlobe.vue";
import AlternisBanner from "../components/AlternisBanner.vue";
import PartnerLogo from "../components/PartnerLogo.vue";
import PhoneCallQRCode from "../components/PhoneCallQRCode.vue";
import { theme } from "@lr-notitia/notitia-ui";

theme.vuetifyTheme.value = "dark";

interface Partner {
	id: string;
	name: string;
	domainId: string;
	instanceDataspaceId: string;
	color: string;
	logo: string;
}

/* NOT NEEDED RIGHT NOW
const partners = ref([
	{
		id: "livereader",
		name: "LiveReader",
		domainId: "c7efbc67-bf2e-47c0-9145-61bee96e6f8c", // ⛑️KINAS
		instanceDataspaceId: isWorld()
			? "0a029588-ce0c-43f1-9675-51ec3df679eb" // .world
			: "1e66ea35-b52b-49cc-ad59-ad816a3f8436", // .dev
		color: "#4db6ac",
		logo: "https://assets.livereader.com/asset/xXCbAJawnlM4BI9h.svg",
	},
	{
		id: "datus",
		name: "Datus",
		domainId: "c7efbc67-bf2e-47c0-9145-61bee96e6f8c", // ⛑️KINAS
		instanceDataspaceId: isWorld()
			? "46677460-f33c-4dc9-9c31-1b91c0849aa0" // .world
			: "a6015e9a-97b8-4074-8c2b-ddfaeb884575", // .dev
		color: "#81c784",
		logo: "https://assets.livereader.com/asset/vhQZZRiJEpRsl3ho.png",
	},
	{
		id: "sse",
		name: "SSE",
		domainId: "c7efbc67-bf2e-47c0-9145-61bee96e6f8c", // ⛑️KINAS
		instanceDataspaceId: isWorld()
			? "cd24725e-f8ab-4c84-a9f5-7132212cca18" // .world
			: "8e9004b0-aed5-42ec-8497-3b5cb7359241", // .dev
		color: "#ffb74d",
		logo: "https://assets.livereader.com/asset/sN1VYSRQGaeN3JYz.png",
	},
	{
		id: "ise",
		name: "iSE",
		domainId: "c7efbc67-bf2e-47c0-9145-61bee96e6f8c", // ⛑️KINAS
		instanceDataspaceId: isWorld()
			? "b88bd5d0-eb63-41bc-ae4d-7638b3f49ff4" // .world
			: "62e85143-bfaa-4097-a6fc-8ad3925efe92", // .dev
		color: "#f06292",
		logo: "https://assets.livereader.com/asset/wQrcdCRU6xQ4dNf3.png",
	},
]);
*/
const partner = ref<Partner>({
	id: "livereader",
	name: "LiveReader",
	domainId: "c7efbc67-bf2e-47c0-9145-61bee96e6f8c", // ⛑️KINAS
	instanceDataspaceId: "b6a880c3-d7d8-4369-a174-c50478d05200",
	color: "#4db6ac",
	logo: "https://assets.livereader.com/asset/xXCbAJawnlM4BI9h.svg",
});

const workspaces = ref<
	{
		id: string;
		timestamp: number;
		clicked: boolean;
	}[]
>([]);

function workspaceClick(id: string) {
	if (!workspaces.value) return;

	const workspace = workspaces.value.find((w) => w.id === id);
	if (!workspace) return;
	workspace.clicked = true;

	const protocol = window.location.protocol; // http: or https:
	const hostname = window.location.hostname; // operator.notitia.dev or operator.notitia.world
	const url = `${protocol}//${hostname}/${partner.value.domainId}/template/${partner.value.instanceDataspaceId}/template/${id}`;
	window.open(url, "_blank");
}

// function isWorld() {
// 	const hostname = window.location.hostname;
// 	return hostname.endsWith("world");
// }

watch(
	() => partner.value,
	(newVal, oldVal) => {
		if (oldVal) {
			api().socket().domain(oldVal.domainId).instance().dataspace(oldVal.instanceDataspaceId).off();
		}
		if (newVal) {
			api()
				.socket()
				.domain(newVal.domainId)
				.instance()
				.dataspace(newVal.instanceDataspaceId)
				.on((message) => {
					const newId = message.workspaces[message.workspaces.length - 1];
					const newWorkspace = {
						id: newId,
						timestamp: Date.now(),
						clicked: false,
					};
					workspaces.value = [newWorkspace, ...workspaces.value];
				});
			// // after 10 seconds, add a dummy workspace
			// setTimeout(() => {
			// 	const dummyWorkspace = {
			// 		id: "dummy",
			// 		timestamp: Date.now(),
			// 		clicked: false,
			// 	};
			// 	workspaces.value = [dummyWorkspace, ...workspaces.value];
			// 	workspaceClick("dummy");
			// }, 10000);
		}
	}
);

// async function checkPopupBlockerStatus() {
// 	try {
// 		const testWindow = window.open("about:blank", "_blank");
// 		if (testWindow == null) {
// 			return "blocked";
// 		}
// 		testWindow.close();
// 		return "allowed";
// 	} catch (e) {
// 		return "blocked";
// 	}
// }
onMounted(async () => {
	api()
		.socket()
		.domain(partner.value.domainId)
		.instance()
		.dataspace(partner.value.instanceDataspaceId)
		.on((message) => {
			const newId = message.workspaces[message.workspaces.length - 1];
			const newWorkspace = {
				id: newId,
				timestamp: Date.now(),
				clicked: false,
			};
			workspaces.value = [newWorkspace, ...workspaces.value];
			workspaceClick(newId);
		});
	// const status = await checkPopupBlockerStatus();
	// if (status === "blocked")
	// 	alert(
	// 		"Please allow popups for this site to enable automatic phone call opening in a new tab. If you don't do this, you can still click on the call in the list to open it manually. To allow popups, click on the icon in the address bar (left next to the URL) and click on 'site settings', then look for 'Pop-ups and redirects'."
	// 	);
});
</script>

<style scoped lang="scss"></style>
